import PropTypes from 'prop-types';
import React, { Component } from 'react';
import LightTable from './../../reusable/LightTable/VeryLightTable';
import withInfiniteScroll from './../../reusable/LightTable/hoc/Scrollable'
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import LoadingSpinner from './../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper';
import storage from "../../utils/storage";

let dateFormat = require('dateformat');

const Table = withInfiniteScroll(LightTable);

export default class SanctionsWarningsTable extends Component {
    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.any),
        loadItems: PropTypes.func,
        resetSanctions: PropTypes.func,
        isLoading: PropTypes.bool,
        totalCount: PropTypes.number,
        entityName: PropTypes.string,
        hasError: PropTypes.bool,
        isFinished: PropTypes.bool,
        companyId: PropTypes.string,
        listingPage: PropTypes.bool,
        backRoute: PropTypes.string
    };

    static defaultProps = {
        items: null,
        companyId: null,
        listingPage: false,
        backRoute: null
    }


    constructor(props) {
        super(props);

        this.loadItems = this.loadItems.bind(this);
        this.noEntries = this.noEntries.bind(this);
        this.unifyDateFormats = this.unifyDateFormats.bind(this);
    }

    loadItems() {
        return this.props.loadItems(this.props.entityName, this.props.companyId)
    }

    unifyDateFormats(date) {
        if(!date) return '';
        let loadDate = date.trim(); //some date strings start with space, and that breaks the dateFormat.
        let loadDateFormatted;
        try {
            loadDateFormatted = dateFormat(new Date(loadDate), "mmm dd, yyyy h:MM TT Z");
        }
        catch (err) {
            loadDateFormatted = date;
            console.log("Not a date; Value received: " + date);
        }
        return loadDateFormatted;
    }

    renderItems() {
        if (this.props.items && this.props.items.length) {
            let auth = storage.getObject("lnei");
            if (auth && auth.authInfo && auth.authInfo.type === "WAM") {
                return this.props.items.map(item => ({
                    key: item.index,
                    content: (
                        <div>
                            <div className={"title"}>
                                <Link to={"/sanctions-reports/report/" + item.index +
                                (this.props.backRoute ? `?backRoute=${this.props.backRoute}` : "")}>
                                    <div dangerouslySetInnerHTML={{__html: item.title}}></div>
                                </Link>
                            </div>
                            <div className={"publication"}>{item.publication}</div>
                            <div className={"content"}>{item.excerpt}</div>
                        </div>),
                    type: item.type,
                    date: this.unifyDateFormats(item.loadDate)
                }))
            } else {
                return this.props.items.map(item => ({
                    key: item.index,
                    content: (
                        <div>
                            <div className={"title"}>
                                <Link to={"/sanctions-reports/report/" + item.index +
                                (this.props.backRoute ? `?backRoute=${this.props.backRoute}` : "")}>
                                    {item.title}
                                </Link>
                            </div>
                            <div className={"publication"}>{item.publication}</div>
                            <div className={"content"}>{item.excerpt}</div>
                        </div>),
                    type: item.type,
                    date: this.unifyDateFormats(item.loadDate)
                }))
            }
        } else {
            return [];
        }
    }

    noEntries() {
        if (this.props.hasError) {
            return <div className="no-entries"><FormattedMessage id={"Entities_Dossier_UIText_dossierServiceUnavailable"}/></div>
        } else {
            return <div className="no-entries"><FormattedMessage id={"Dashboard_Charts_UIText_dashboard.sanctionsPod.noSanctions"}/></div>
        }
    }

    render() {
        const headers = [
            { key: "content", label: <FormattedMessage
                id="General_CoreFunctionality_UIText_countBox.showTotal"
                values={{resultsCount: this.props.totalCount}} />
            },
            { key: "type", label: <FormattedMessage id={"Entities_Dossier_UIText_type"}/>},
            { key: "date", label: <FormattedMessage id={"General_CoreFunctionality_UIText_date"}/>}
        ]
        return (
            <div className={"sanctions-warnings__table " + (this.props.hasError ? "has-error" : "")}>
                { this.props.isLoading && this.props.items.length === 0 ? (
                    <LoadingSpinner isLoading={true} customClasses={"small"}/>
                ) : (
                    <Table headerItems={headers}
                           listItems={this.renderItems()}
                           itemCount={this.props.totalCount}
                           loadItems={this.loadItems}
                           noEntries={this.noEntries}
                           isFinished={this.props.isFinished}
                           fullScreen={this.props.listingPage}
                           withPromise={false} />
                )}

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/pages/SanctionsWarnings/SanctionsWarningsTable.jsx